import { initializeApp, type FirebaseApp } from 'firebase/app'
import { getMessaging, type Messaging } from 'firebase/messaging'
import isSSR from '@/_base/isSSR'

let app: FirebaseApp | null = null
let messagingInstance: Messaging | null = null

function getFirebaseConfig() {
  return {
    apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
    authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.VUE_APP_FIREBASE_APP_ID
  }
}

export function getFirebaseApp(): FirebaseApp | null {
  if (isSSR) return null
  if (!app) {
    const config = getFirebaseConfig()
    if (!config.apiKey || !config.messagingSenderId) return null
    app = initializeApp(config)
  }
  return app
}

export function getFirebaseMessaging(): Messaging | null {
  if (isSSR) return null
  const firebaseApp = getFirebaseApp()
  if (!firebaseApp) return null
  if (!messagingInstance) {
    messagingInstance = getMessaging(firebaseApp)
  }
  return messagingInstance
}
